module.exports = __webpack_public_path__ + "static/media/NG.af6fd570.png";